import React from 'react';

import Table from '../design/shared/table';
import { Box } from '../design/css';

const ListDetails = (data, label) => {
  if (!(data && data.length)) return null;

  const tableHeaders = { product: label };
  return (
    <Box pr={24} pl={24} width={40} mdWidth={100} pb={12}>
      <Box pt={12}>
        <Table
          title={label}
          headers={tableHeaders}
          data={data.map(v => {
            return { product: v };
          })}
          totalRecords={data.length}
        />
      </Box>
    </Box>
  );
};

export default ListDetails;
